import { BaseService } from "./baseService";
import httpRequest from "./index";
import {
    type Customer,
    type CustomerUpdateEmailForm,
    type CustomerUpdatePasswordForm,
    type CustomerVo,
    type findPasswordForm,
    type SupplierSelectorVo
} from "@zhihaoscm/entity";

export class CustomerService extends BaseService<Customer, CustomerVo, any, any> {
    // 供应商下拉列表
    async getSupplierSelector(name: string): Promise<SupplierSelectorVo[]> {
        const { data } = await this.service.get(`${this.path}/product/supplier-selector`, { params: { name } });
        return data;
    }

    // 用户账户查询
    // async getCustomerAccount(id: number): Promise<CustomerAccount> {
    //     const { data } = await this.service.get(`${this.path}/customer/account/${id}`);
    //     return data;
    // }

    // 获取用户真实姓名
    async getCustomerRealName(id: number): Promise<string> {
        const { data } = await this.service.get(`${this.path}/customer/get/realname/${id}`);
        return data;
    }

    // 获取用户真实手机号
    async getCustomerRealMobile(id: number): Promise<string> {
        const { data } = await this.service.get(`${this.path}/customer/get/mobile/${id}`);
        return data;
    }

    // 获取客户当前账户状态
    public async getCustomerState(id: number): Promise<string> {
        const { data } = await this.service.get(`${this.path}/customer/get/state/${id}`);
        return data;
    }

    /**找回密码*/
    public async findPassword(params: findPasswordForm): Promise<Customer> {
        const { data } = await this.service.put(`${this.path}/customer/password`, params);
        return data;
    }

    /**更新密码*/
    public async updatePassword(params: CustomerUpdatePasswordForm) {
        const { data } = await this.service.put(`${this.path}/customer/password/modification`, params);
        return data;
    }

    /**更新邮箱*/
    public async updateEmail(params: CustomerUpdateEmailForm) {
        const { data } = await this.service.put(`${this.path}/customer/email`, params);
        return data;
    }
}

export const customerService = new CustomerService("", httpRequest);
